import React, { Component } from 'react';
import styles from './step-by-step.css';
import UserInput from './s_user_input';
import UserSliderInputDruckfarbe from './s_slider_druckfarbe';
import UserSliderInputTextil from './s_slider_textil';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'

class Steps extends Component{

  constructor(props){
    super(props)
    this.state = {
      currentStep: 0,
      lastStep: 5,// 6 in total
      completedSteps: [],// Have a simple array to keep track of completed steps.
      finishedAllSteps: false
    }
  }

  toggleStepsOverlays = () => {
    this.props.toggleStepByStep()
  }

  handleUserInputChange = (value, name) => {
    this.props.handleUserInputChange(value, name)
  }

  handleChangeColor = (selected) => {
    this.props.onChangeColor(selected);
  }

  handleChangeTextile = (selected) => {
    this.props.onChangeTextile(selected);
  }

  pushToCompletedSteps = (step) => {
    const completedSteps = this.state.completedSteps
    const completedStep = completedSteps.filter(item => item.step === step)[0]
    
    if(completedStep !== undefined && completedStep.step !== step && !this.state.isFinished){
      completedSteps.push({
        step: step
      })
    }
    else if(completedStep === undefined){
      completedSteps.push({
        step: step
      })
    }
  }

  renderStepButton = () => {
    const isLastStep = this.state.currentStep === this.state.lastStep ? true : false
    const buttonWording = isLastStep ? "Anwenden" : "Weiter"
    return(
      <button onClick={() => this.goToNextStep(isLastStep)}>{buttonWording}</button>
    )
  }

  renderPrevStepButton = () => {
    const isFirstStep = this.state.currentStep === 0 ? true : false
    if(!isFirstStep){
      return(
        <button onClick={() => this.goToPreviousStep()}>Zurück</button>
      )
    }
    else{
      return(
        <button onClick={() => this.goToPreviousStep()} disabled="disabled">Zurück</button>
      )
    }
  }

  goToPreviousStep = () => {
    const stepTo = this.state.currentStep >= 0 ? this.state.currentStep - 1 : this.state.currentStep
    this.setState({
      currentStep: stepTo > 0 ? stepTo : 0
    })
  }

  goToNextStep = (shouldCloseModal = false) => {
    const stepTo = this.state.currentStep <= this.state.lastStep ? this.state.currentStep + 1 : this.state.currentStep
    const isFinished = stepTo > this.state.lastStep ? true : false

    this.pushToCompletedSteps(this.state.currentStep)

    this.setState({
      currentStep: stepTo > this.state.lastStep ? this.state.lastStep : stepTo,
      finishedAllSteps: isFinished
    })

    if(shouldCloseModal){
      this.toggleStepsOverlays()
    }
  }

  goToStep = (step) => {
    this.setState({
      currentStep: step
    })
  }

  renderStepView = () => {
    var renderedSteps = []
    const completedSteps = this.state.completedSteps

    for (let step = 0; step <= this.state.lastStep; step++) {
      const currentStepInCompletedList = completedSteps.filter(item => item.step === step)[0]
      const isCurrentStep = step === this.state.currentStep ? true : false
      const isCompletedStep = currentStepInCompletedList !== undefined && currentStepInCompletedList.step === step ? true : false

      if(isCurrentStep){
        renderedSteps.push(
          <li key={`step-${step}`} className={styles.currentStep}>{step+1}</li>
        )
      }
      else if(isCompletedStep){
        renderedSteps.push(
          <li key={`step-${step}`} className={styles.completedStep} onClick={() => this.goToStep(step)}>{step+1}</li>
        )
      }
      else{
        renderedSteps.push(
          <li key={`step-${step}`}>{step+1}</li>
        )
      }
    }
    return renderedSteps
  }

  returnCurrentStep = (calculatorState) => {
    //const completedSteps = this.state.completedSteps;
    //const lastCompletedStep = completedSteps !== undefined ? completedSteps[completedSteps.length - 1] : null 
    const currentStep = this.state.currentStep

    if(currentStep === 0){
      return(
        <UserInput
          description={Lang.translate('calculator:demandVolume', this.props.location.pathname)}
          unitInfo={Lang.translate('calculator:pieceWeek', this.props.location.pathname)}
          name="demandVolume"
          onChange={this.handleUserInputChange}
          value={calculatorState.demandVolume}
          styles={styles}
          icon={null}
          helpText={Lang.translate('steps:demandVolumeHelp', this.props.location.pathname)}
          step={currentStep}
        />
      )
    }
    else if(currentStep === 1){
      return(
        <UserInput
          description={Lang.translate('calculator:productionWeeks', this.props.location.pathname)}
          unitInfo={Lang.translate('calculator:weekYear', this.props.location.pathname)}
          onChange={this.handleUserInputChange}
          value={calculatorState.productionWeeks}
          name="productionWeeks"
          styles={styles}
          helpText={Lang.translate('steps:productionWeeksHelp', this.props.location.pathname)}
          step={currentStep}
        />
      )
    }
    else if(currentStep === 2){
      return(
        <UserInput
          description={Lang.translate('calculator:productionHours', this.props.location.pathname)}
          unitInfo={Lang.translate('calculator:hoursDay', this.props.location.pathname)}
          onChange={this.handleUserInputChange}
          value={calculatorState.productionHours}
          name="productionHours"
          styles={styles}
          helpText={Lang.translate('steps:productionHoursHelp', this.props.location.pathname)}
          step={currentStep}
        />
      )
    }
    else if(currentStep === 3){
      return(
        <UserInput
          description={Lang.translate('calculator:listPrice', this.props.location.pathname)}
          unitInfo={Lang.translate('calculator:piece', this.props.location.pathname)}
          onChange={this.handleUserInputChange}
          value={calculatorState.listPrice}
          name="listPrice"
          styles={styles}
          helpText={Lang.translate('steps:listPriceHelp', this.props.location.pathname)}
          step={currentStep}
        />
      )
    }
    else if(currentStep === 4){
      return(
        <UserSliderInputDruckfarbe
            styles={styles}
            onChange={this.handleChangeColor}
            name="druck"
            value={calculatorState.printColorPercentage}
            textilePercentage={calculatorState.textileColorPercentage}
            label={Lang.translate('calculator:printColor', this.props.location.pathname)}
            showPercentage='true'
            helpText={Lang.translate('steps:printColorHelp', this.props.location.pathname)}
            white={Lang.translate('calculator:white', this.props.location.pathname)}
          />
      )
    }
    else if(currentStep === 5){
      return(
        <UserSliderInputTextil
          styles={styles}
          onChange={this.handleChangeTextile}
          name="textile"
          value={calculatorState.textileColorPercentage}
          label={Lang.translate('calculator:textileColor', this.props.location.pathname)}
          showPercentage='true'
          helpText={Lang.translate('steps:textileHelp', this.props.location.pathname)}
          white={Lang.translate('calculator:white', this.props.location.pathname)}
          colourful={Lang.translate('calculator:colourful', this.props.location.pathname)}
          dark={Lang.translate('calculator:dark', this.props.location.pathname)}
        />
      )
    }
    
  }
  
  render() {
    const calculatorState = this.props.calculatorState;
    const currentStepView = this.props.isOpen ? this.returnCurrentStep(calculatorState) : null
    const nextButton = this.props.isOpen ? this.renderStepButton() : null
    const prevButton = this.props.isOpen ? this.renderPrevStepButton() : null
    const stepView = this.props.isOpen ? this.renderStepView() : null
    return(
      <div className={styles.overlay} style={this.props.isOpen ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'}}>
        <div className={styles.overlayContainer}>
          <div className={styles.closeButton} onClick={() => this.toggleStepsOverlays()}>
          <svg width="25px" height="25px" viewBox="0 0 62 62" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <defs></defs>
              <g id="Symbols" stroke="none" fill="none">
                  <g id="Exit" transform="translate(1.000000, 1.000000)">
                      <g>
                          <circle id="Oval-2" stroke="#FFFFFF" fill="#0D2EA0" cx="30" cy="30" r="30"></circle>
                          <g id="Group" transform="translate(30.500000, 30.500000) rotate(45.000000) translate(-30.500000, -30.500000) translate(13.000000, 13.000000)" fill="#FFFFFF">
                              <rect id="Rectangle-8" x="0" y="15" width="35" height="5"></rect>
                              <rect id="Rectangle-8" x="15" y="0" width="5" height="35"></rect>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
          </div>

          <div className={styles.stepContainer}>
            <p className={styles.headerStep}>{this.state.currentStep + 1}</p>
            {currentStepView}
          </div>
          <div className={styles.controls}>
            <div className={styles.prev}>
              {prevButton}
            </div>
            <div className={styles.next}>
              {nextButton}
            </div>
            <ul>
              {stepView}
            </ul>
          </div>
          
        </div>
      </div>
    );
  }
}

export default withRouter(Steps);



// WEBPACK FOOTER //
// ./src/components/calculator/step-by-step/step-by-step.js